import { render, staticRenderFns } from "./CompTabelaExibirProcessosMontados.vue?vue&type=template&id=36a8a88c&"
import script from "./CompTabelaExibirProcessosMontados.vue?vue&type=script&lang=js&"
export * from "./CompTabelaExibirProcessosMontados.vue?vue&type=script&lang=js&"
import style0 from "./CompTabelaExibirProcessosMontados.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports